import type { StateDeclarationFn } from './types';

export default (function () {
  return [
    {
      parent: 'tpa',
      abstract: true,
      name: 'social-groups',
      url: '?social-groups-ooi-override',
    },
    {
      parent: 'tpa',
      name: 'pricing-plans',
      url: '?{appSectionParams}',
    },
    {
      parent: 'tpa',
      name: 'members',
      url: '/:memberId',
    },
    {
      name: 'members.profile',
    },
  ];
} as StateDeclarationFn);
